import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import YesIcon from '@material-ui/icons/FindReplace';
import NoIcon from '@material-ui/icons/NotInterested';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


const styles = theme => ({
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.secondary[900]
  },
  toolbarRootForce: {
    padding: 0,
    backgroundColor: red[700]
  },
  titleHead: {
    margin: '4px 12px',
    fontSize: '18px',
    color: '#ffffff'
  },
  contentMessage: {
    padding: '36px 12px',
    fontSize: '16px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  bttnSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600]
    }
  },
  fabProgress: {
    margin: theme.spacing.unit,
    position: 'absolute',
    right: 18,
    top: 0,
    zIndex: 1
  }
});


class ConfirmationDialog extends React.Component {


  handleClose = () => {
    this.props.handleClose();
  };


  render() {
    const { classes } = this.props;
    const buttonClassname = classNames({ [classes.bttnSuccess]: this.props.success });

    return (
      <div>
        <Dialog
          fullWidth
          maxWidth='sm'
          open={this.props.openConfirmationDialog}
        >

          <Paper>
            <Toolbar className={typeof (this.props.confirmationMessage) === 'string' ?
              this.props.confirmationMessage.indexOf('possuem reservas associadas à totalidade de viaturas') > -1
                || this.props.confirmationMessage.indexOf('já possui uma encomenda associada') > -1
                || this.props.confirmationMessage.indexOf('encontra-se encerrado') > -1
                || this.props.confirmationMessage.indexOf('viatura encomendada e entregue') > -1
                ? classes.toolbarRootForce : classes.toolbarRoot : classes.toolbarRoot}>
              <Typography variant='title' className={classes.titleHead}>
                {this.props.confirmationQuestion}
              </Typography>
            </Toolbar>
          </Paper>

          <DialogContentText className={classes.contentMessage}>
            {this.props.confirmationMessage}
          </DialogContentText>

          <Divider />
          <DialogActions disableActionSpacing>
            <div>
              <Toolbar>
                <Tooltip title='Cancelar' placement='bottom' >
                  <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.props.cancelFunction}>
                    <CloseIcon />
                  </Button>
                </Tooltip>
                {this.props.isToAskChangeReservations === false || this.props.noFunction === undefined || this.props.yesFunction === undefined ?
                  <Tooltip title='Confirmar' placement='bottom' >
                    <Button disabled={this.props.loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.props.confirmationFunction}>
                      <CheckIcon />
                      <div>{this.props.success}</div>
                    </Button>
                  </Tooltip>
                  :
                  <React.Fragment>
                    <Tooltip key={'0'} title='Não' placement='bottom' >
                      <Button disabled={this.props.loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.props.noFunction}>
                        <NoIcon />
                        <div>{this.props.success}</div>
                      </Button>
                    </Tooltip>
                    <Tooltip key={'1'} title='Sim' placement='bottom' >
                      <Button disabled={this.props.loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.props.yesFunction}>
                        <YesIcon />
                        <div>{this.props.success}</div>
                      </Button>
                    </Tooltip>
                  </React.Fragment>
                }
                {this.props.loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
              </Toolbar>
            </div>
          </DialogActions>

        </Dialog>
      </div>
    )
  }
}

ConfirmationDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ConfirmationDialog);


// WEBPACK FOOTER //
// ./src/components/Utils/ConfirmationDialog.js